<modal-form-container
  title="Segments in this message"
  className="md:w-[600px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="sl">
      @if (selectedSegments.length > 0) {
        <p class="sl__lead">
          Everyone in {{ selectedSegments.length === 1 ? "this segment" : "these segments" }} gets the message. People in more than one get it
          once.
        </p>
        <ul class="sl__list">
          @for (item of selectedSegments; track $index) {
            <li class="sl__row">
              <span class="sl__text">
                <span class="sl__name">{{ item.name || "Unnamed segment" }}</span>
                @if (item.description) {
                  <span class="sl__meta">{{ item.description }}</span>
                }
              </span>
              <button
                type="button"
                class="bk-icon-btn"
                [attr.aria-label]="'Remove ' + (item.name || 'segment')"
                matTooltip="Remove from message"
                (click)="handleRemoveSegment(item)"
              >
                <span class="bk-sym" aria-hidden="true">close</span>
              </button>
            </li>
          }
        </ul>
      } @else {
        <p class="sl__empty">No segments chosen. Choose Segments in the Recipients section to add everyone matching a saved filter.</p>
      }

      <div class="sl__foot">
        <button type="button" class="bk-btn bk-btn--primary" (click)="closeModal()">Done</button>
      </div>
    </div>
  }
</modal-form-container>
